import type { FC } from "react";
import React, { useCallback, useState } from "react";
import styles from "./Summary.module.scss";
import Collapse from "../../../../../shared-components/css-modules/lexus/molecules/Collapse";
import Popover from "../../../../../shared-components/css-modules/lexus/vendor/popover/Popover";
import Text from "../../../../../shared-components/css-modules/lexus/atoms/Text";
import Button from "../../../../../shared-components/css-modules/lexus/atoms/Button";
import Icon from "../../../../../shared-components/css-modules/lexus/atoms/Icon";
import { trackOrderOverviewSpecsPanelOpen } from "../../../../utils/tracking";
import { IntegratedEcoConsumptionSection } from "../../../../../../shared-modules/eco-consumption-section/components/IntegratedEcoConsumptionSection";
import { useEcoConsumptionConfiguration } from "../../../../hooks/useAphEcoConsumptionConfiguration";

type EcoSpecsProps = {
    alternateFlow?: boolean;
};
export const SummaryEcoConsumption: FC<EcoSpecsProps> = (props) => {
    const { alternateFlow } = props;

    const [ecoSpecsIsOpen, setEcoSpecsIsOpen] = useState(alternateFlow);
    const ecoConsumptionConfiguration = useEcoConsumptionConfiguration();

    const handleClick = useCallback((event: React.MouseEvent, changeOpenState: boolean) => {
        event.stopPropagation();
        event.preventDefault();
        if (changeOpenState) setEcoSpecsIsOpen((oldIsOpen) => !oldIsOpen);
    }, []);

    if (!ecoConsumptionConfiguration) return null;

    return (
        <Collapse
            onClick={(event) => handleClick(event, true)}
            open={ecoSpecsIsOpen}
            summary={
                <Text tag="h3" variant="apheleia-list-item-small">
                    {ecoConsumptionConfiguration.title}
                </Text>
            }
            onChange={(isOpen) => {
                trackOrderOverviewSpecsPanelOpen(!!isOpen, "eco-specs");
            }}
        >
            <ul role="list" className={styles["config-sublist"]}>
                {ecoConsumptionConfiguration && (
                    <li>
                        <div className={styles.contentborder}>
                            <IntegratedEcoConsumptionSection
                                ecoConsumptionConfiguration={ecoConsumptionConfiguration}
                                PopoverTooltip={(tooltip: { content: string }) => (
                                    <Popover placement="top">
                                        <Popover.Trigger>
                                            <Button
                                                variant="clean"
                                                onClick={(event) => {
                                                    event.stopPropagation();
                                                }}
                                            >
                                                <Icon variant="info" sizing="md" aria-hidden="true" />
                                            </Button>
                                        </Popover.Trigger>
                                        <Popover.Content onClick={(event) => handleClick(event, false)}>
                                            <div dangerouslySetInnerHTML={{ __html: tooltip.content }} />
                                        </Popover.Content>
                                    </Popover>
                                )}
                            />
                        </div>
                    </li>
                )}
            </ul>
        </Collapse>
    );
};
